/*
 *   File : delete.js
 *   Author URI : https://evoqins.com
 *   Description : UI element which asks for confirmation while removing funds.
 *   Integrations : null
 *   Version : v1.1
 */
/* import packages */
import { useEffect, useState } from "react";

/* import components */
import { GradientButton, OutlineButton } from "../Cta";
import { Icon } from "../Icon";
import { toast } from "react-toastify";

/* import styles */
import style from "../../Styles/Components/delete.module.scss";

/* import helper */
import { closeModal } from "../../Helper/helper-function";
import APIService from "../../Services/api-service";

const ConfirmDeleteModal = (props) => {
    const [apiLoader, setApiLoader] = useState(false);

    useEffect(() => {
        var my_modal = document.getElementById("confirm-delete-modal");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
        //eslint-disable-next-line
    }, [props.close]);

    const _handleCancel = () => {
        props.close();
    }

    const _handleDelete = () => {
        document.getElementById("close-modal").dispatchEvent(new Event("click"));
        props.confirmDelete();
    };


    return (
        <div className={`modal fade ${style.e_delete}`}
            id="confirm-delete-modal"
            tabIndex="-1"
            aria-labelledby="confirm-delete-modal"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-white text-center d-flex align-items-center padding-32px-all ${style.e_content} `}>
                    <div className="col-12 d-flex justify-content-between">

                        <Icon icon={"close"}
                            size={24}
                            id="close-modal"
                            className="cursor-pointer ms-auto e-modal-close-btn"
                            data-bs-dismiss="modal" />
                    </div>

                    <div className={`border-all border-all-2px  ${props.status ? 'border-pastel-red' : 'border-cream-green'} rounded-circle p-3`}>
                        <Icon icon={props.icon}
                            size={40}
                        />
                    </div>


                    <p className="color-eerie-black e-poppins-medium e-font-18 mt-4 mb-0">
                        {props.content}
                    </p>

                    <div className="d-flex gap-8px align-items-center justify-content-center pt-4  px-5">
                        <OutlineButton label="Cancel"
                            cancel="modal"
                            className="padding-16px-tb padding-36px-lr white-space-nowrap bg-white e-font-16 e-poppins-regular "
                            handleClick={_handleCancel} />
                        <GradientButton label={props.btnLabel}
                            className={`padding-16px-tb padding-60px-lr e-font-16 `}
                            cancel="modal"
                            loading={apiLoader}
                            onPress={_handleDelete} />
                    </div>
                </div>
            </div>
        </div>
    )
}


ConfirmDeleteModal.defaultProps = {
    close: () => { },
}

export default ConfirmDeleteModal